import { isRetiredProvider } from "@/constants/providers";
import {
	CreateMyOperatorSupportRequest,
	CreateMyOperatorSupportResponse,
	DeleteMyOperatorHrefBackUrlsResponse,
	GetMeResponse,
	GetMyDemoCreditResponse,
	GetMyGameSettingsByIdResponse,
	GetMyGameSettingsResponse,
	GetMyOperatorHrefBackUrlsRequest,
	GetMyOperatorHrefBackUrlsResponse,
	GetMyBanditStatsResponse,
	GetMyBanditPerformanceResponse,
	GetMyBanditBundlesResponse,
	GetMyOperatorPresetsByIdResponse,
	GetMyOperatorPresetsResponse,
	GetMyPoolsResponse,
	GetMyReportsResponse,
	GetMyFailedSpinSummaryTodayResponse,
	GetMySpinOrderByUsernameRequest,
	GetMySpinOrderByUsernameResponse,
	GetSpinBetDetailRequest,
	GetSpinBetDetailResponse,
	GetMySpinOrderSummaryByUsernamesRequest,
	GetMySpinOrderSummaryByUsernamesResponse,
	GetMyWinningQuotaRequest,
	GetMyWinningQuotaResponse,
	ResetMyPrivateKeyResponse,
	SetMyDemoCreditRequest,
	SetMyDemoCreditResponse,
	SetMyGameSettingRequest,
	SetMyGameSettingResponse,
	SetMyOperatorPresetRequest,
	SetMyOperatorPresetResponse,
	UpdateMyOperatorSupportRequest,
	UpdateMyOperatorSupportResponse,
	UpdateMyRequest,
	UpdateMyResponse,
	UpdateMyDefaultProviderGameUrlRequest,
	UpdateMyDefaultProviderGameUrlResponse,
	UpdateMyBanditConfigRequest,
	UpdateMyBanditConfigResponse,
	SetMyBanditControlRequest,
	GetMyBanditControlResponse,
	ResetMyBanditStatsRequest,
	ResetMyBanditStatsResponse,
	ResetMyBanditLearningResponse,
	GetMyOperatorProvidersResponse,
	GetMyProviderGameUrlsResponse,
	GetMyOperatorSupportsResponse,
	GetOperatorActivityLogRequest,
	GetOperatorActivityLogResponse,
	BuyOperatorQuotaDto,
	OperatorBuyQuotaResponse,
	OperatorBuyQuotaDemoResponse,
	BuyOperatorQuotaDemoDto,
	GetOperatorBuyQuotaActivityLogResponse,
	GetOperatorBuyQuotaActivityLogRequest,
} from "@/types/operator";
import axios from "@/utils/axios";

export const getOperatorsMe = async (): Promise<GetMeResponse> => {
	try {
		const response = await axios.get(`/operators/me`);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const resetMyPrivateKey =
	async (): Promise<ResetMyPrivateKeyResponse> => {
		try {
			const response = await axios.post(`/operators/reset-my-private-key`);
			return response.data;
		} catch (error: any) {
			throw error.response.data;
		}
	};

export const updateMy = async (
	payload: UpdateMyRequest,
): Promise<UpdateMyResponse> => {
	try {
		const response = await axios.put(`/operators/update-my`, payload);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const getMyWinningQuota = async (
	payload: GetMyWinningQuotaRequest,
): Promise<GetMyWinningQuotaResponse> => {
	try {
		const response = await axios.post(
			`/operators/get-my-winning-quota`,
			payload,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const getMyGameSettings =
	async (): Promise<GetMyGameSettingsResponse> => {
		try {
			const response = await axios.post(`/operators/get-my-game-settings`);
			return response.data;
		} catch (error: any) {
			throw error.response.data;
		}
	};

export const getMyGameSettingsById = async (
	id: string,
): Promise<GetMyGameSettingsByIdResponse> => {
	try {
		const response = await axios.post(`/operators/get-my-game-settings/${id}`);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const getMyOperatorPresets =
	async (): Promise<GetMyOperatorPresetsResponse> => {
		try {
			const response = await axios.post(`/operators/get-my-operator-presets`);
			return response.data;
		} catch (error: any) {
			throw error.response.data;
		}
	};

export const getMyOperatorPresetsById = async (
	id: string,
): Promise<GetMyOperatorPresetsByIdResponse> => {
	try {
		const response = await axios.post(
			`/operators/get-my-operator-presets/${id}`,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const getMyPools = async (): Promise<GetMyPoolsResponse> => {
	try {
		const response = await axios.post(`/operators/get-my-pools`);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const getMyReports = async (): Promise<GetMyReportsResponse> => {
	try {
		const response = await axios.post(`/operators/get-my-reports`);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const getMySpinOrderSummaryByUsernames = async (
	payload: GetMySpinOrderSummaryByUsernamesRequest,
): Promise<GetMySpinOrderSummaryByUsernamesResponse> => {
	try {
		const response = await axios.post(
			`/operators/get-my-spin-order-summary-by-usernames`,
			payload,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const getMySpinOrderByUsernames = async (
	payload: GetMySpinOrderByUsernameRequest,
): Promise<GetMySpinOrderByUsernameResponse> => {
	try {
		const response = await axios.post(
			`/operators/get-my-spin-order-by-username`,
			payload,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const getMySpinBetDetail = async (
	payload: GetSpinBetDetailRequest,
): Promise<GetSpinBetDetailResponse> => {
	try {
		const response = await axios.post(
			`/operators/get-my-spin-bet-detail`,
			payload,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const getMyFailedSpinSummaryToday =
	async (): Promise<GetMyFailedSpinSummaryTodayResponse> => {
		try {
			const response = await axios.get(
				`/operators/get-my-failed-spin-summary-today`,
			);
			return response.data;
		} catch (error: any) {
			throw error.response.data;
		}
	};

export const setMyGameSetting = async (
	payload: SetMyGameSettingRequest,
): Promise<SetMyGameSettingResponse> => {
	try {
		const response = await axios.post(
			`/operators/set-my-game-setting`,
			payload,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const setMyOperatorPreset = async (
	payload: SetMyOperatorPresetRequest,
): Promise<SetMyOperatorPresetResponse> => {
	try {
		const response = await axios.post(
			`/operators/set-my-operator-preset`,
			payload,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const getMyDemoCredit = async (): Promise<GetMyDemoCreditResponse> => {
	try {
		const response = await axios.post(`/operators/demo/get-my-credit`);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const setMyDemoCredit = async (
	payload: SetMyDemoCreditRequest,
): Promise<SetMyDemoCreditResponse> => {
	try {
		const response = await axios.post(`/operators/demo/set-my-credit`, payload);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const getMyOperatorHrefBackUrls = async (
	payload: GetMyOperatorHrefBackUrlsRequest,
): Promise<GetMyOperatorHrefBackUrlsResponse> => {
	try {
		const response = await axios.post(
			`/operators/get-my-operator-href-back-urls`,
			payload,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const deleteMyOperatorHrefBackUrls = async (
	id: string,
): Promise<DeleteMyOperatorHrefBackUrlsResponse> => {
	try {
		const response = await axios.delete(
			`/operators/delete-my-operator-href-back-urls/${id}`,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const getMyOperatorSupports =
	async (): Promise<GetMyOperatorSupportsResponse> => {
		try {
			const response = await axios.post(`/operators/get-my-operator-supports`);
			return response.data;
		} catch (error: any) {
			throw error.response.data;
		}
	};

export const createMyOperatorSupport = async (
	payload: CreateMyOperatorSupportRequest,
): Promise<CreateMyOperatorSupportResponse> => {
	try {
		const response = await axios.post(
			`/operators/create-my-operator-support`,
			payload,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const updateMyOperatorSupport = async (
	payload: UpdateMyOperatorSupportRequest,
): Promise<UpdateMyOperatorSupportResponse> => {
	try {
		const response = await axios.put(
			`/operators/update-my-operator-support`,
			payload,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const getMyOperatorProviders =
	async (): Promise<GetMyOperatorProvidersResponse> => {
		try {
			const response = await axios.post(`/operators/get-my-operator-providers`);
			const body: GetMyOperatorProvidersResponse = response.data;
			// Every provider list in the back office reads this; a retired provider's row is history only.
			return {
				...body,
				data: (body.data ?? []).filter(
					(provider) => !isRetiredProvider(provider.providerName),
				),
			};
		} catch (error: any) {
			throw error.response.data;
		}
	};

export const getMyOperatorProviderGameUrlsById = async (
	providerId: string,
): Promise<GetMyProviderGameUrlsResponse> => {
	try {
		const response = await axios.post(
			`/operators/get-my-provider-game-urls/${providerId}`,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const updateMyDefaultProviderGameUrl = async (
	payload: UpdateMyDefaultProviderGameUrlRequest,
): Promise<UpdateMyDefaultProviderGameUrlResponse> => {
	try {
		const response = await axios.post(
			`/operators/update-my-default-provider-game-url`,
			payload,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const updateMyBanditConfig = async (
	payload: UpdateMyBanditConfigRequest,
): Promise<UpdateMyBanditConfigResponse> => {
	try {
		const response = await axios.post(
			`/operators/update-my-bandit-config`,
			payload,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const getMyBanditStats = async (
	providerId: string,
): Promise<GetMyBanditStatsResponse> => {
	try {
		const response = await axios.post(`/operators/get-my-bandit-stats`, {
			providerId,
		});
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const getMyBanditPerformance = async (
	providerId: string,
	range?: { startDate?: string; endDate?: string },
): Promise<GetMyBanditPerformanceResponse> => {
	try {
		const response = await axios.post(`/operators/get-my-bandit-performance`, {
			providerId,
			...range,
		});
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const getMyBanditBundles =
	async (): Promise<GetMyBanditBundlesResponse> => {
		try {
			const response = await axios.post(`/operators/get-my-bandit-bundles`);
			return response.data;
		} catch (error: any) {
			throw error.response.data;
		}
	};

export const setMyBanditControl = async (
	payload: SetMyBanditControlRequest,
): Promise<GetMyBanditControlResponse> => {
	try {
		const response = await axios.post(
			`/operators/set-my-bandit-control`,
			payload,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const getMyBanditControl =
	async (): Promise<GetMyBanditControlResponse> => {
		try {
			const response = await axios.post(`/operators/get-my-bandit-control`);
			return response.data;
		} catch (error: any) {
			throw error.response.data;
		}
	};

// Start a fresh A/B measurement window. Non-destructive on the server — it stamps an
// experiment epoch, it does not delete stat rows.
export const resetMyBanditStats = async (
	payload: ResetMyBanditStatsRequest,
): Promise<ResetMyBanditStatsResponse> => {
	try {
		const response = await axios.post(
			`/operators/reset-my-bandit-stats`,
			payload,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

// Wipe the bandit's learned arms for this operator (changes what players are served).
export const resetMyBanditLearning =
	async (): Promise<ResetMyBanditLearningResponse> => {
		try {
			const response = await axios.post(`/operators/reset-my-bandit-learning`);
			return response.data;
		} catch (error: any) {
			throw error.response.data;
		}
	};

export const getOperatorActivityLog = async (
	payload: GetOperatorActivityLogRequest,
): Promise<GetOperatorActivityLogResponse> => {
	try {
		const response = await axios.post(
			`/operators/get-my-activity-log`,
			payload,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const purchaseQuota = async (
	payload: BuyOperatorQuotaDto,
): Promise<OperatorBuyQuotaResponse> => {
	try {
		const response = await axios.post(`/operators/buy-my-quota`, payload);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const purchaseQuotaDemo = async (
	payload: BuyOperatorQuotaDemoDto,
): Promise<OperatorBuyQuotaDemoResponse> => {
	try {
		const response = await axios.post(`/operators/buy-my-quota-demo`, payload);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const purchaseQuotaDemoByCrypto = async (payload: {
	chain: string;
	dateIncrement: number;
	note?: string;
}): Promise<{
	id: string;
	address: string;
	amount: number;
	currency: string;
	dateIncrement: number;
}> => {
	try {
		const response = await axios.post(
			`/operators/buy-my-quota-demo/crypto`,
			payload,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const confirmCryptoPaymentDemo = async (payload: {
	paymentId: string;
	transactionHash: string;
}): Promise<{ success: boolean; message: string }> => {
	try {
		const response = await axios.post(
			`/operators/buy-my-quota-demo/crypto-confirm`,
			{
				id: payload.paymentId,
				txHash: payload.transactionHash,
			},
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const purchaseQuotaCrypto = async (payload: {
	chain: string;
	winningQuotaAmount: number;
	note?: string;
}): Promise<{
	id: string;
	address: string;
	amount: number;
	currency: string;
}> => {
	try {
		const response = await axios.post(
			`/operators/buy-my-quota/crypto`,
			payload,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const confirmCryptoPayment = async (payload: {
	paymentId: string;
	transactionHash: string;
}): Promise<{ success: boolean; message: string }> => {
	try {
		const response = await axios.post(
			`/operators/buy-my-quota/crypto-confirm`,
			{
				id: payload.paymentId,
				txHash: payload.transactionHash,
			},
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const getOperatorBuyQuotaActivityLog = async (
	payload: GetOperatorBuyQuotaActivityLogRequest,
): Promise<GetOperatorBuyQuotaActivityLogResponse> => {
	try {
		const response = await axios.post(
			`/operators/get-my-buy-quota-activity-log`,
			payload,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};

export const getOperatorBuyQuotaActivityLogSummary = async (
	payload: GetOperatorBuyQuotaActivityLogRequest,
): Promise<{
	totalWinningQuotaBuy: number;
	totalWinningQuotaBuyUnsuccessful: number;
}> => {
	try {
		const response = await axios.post(
			`/operators/get-my-buy-quota-activity-log-summary`,
			payload,
		);
		return response.data;
	} catch (error: any) {
		throw error.response.data;
	}
};
